<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container>
      <!-- 主表单区域 -->
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="12" >
            <a-form-item :label="$t('label.batchNo')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!--<a-input v-decorator="['breedCode']" placeholder="请输入批次编号" ></a-input>-->
              <a-select placeholder="请选择批次编号" showSearch option-filter-prop="children"   v-decorator="['breedCode',validatorRules.breedCode]" @change="breedCodeChanged">
                <a-select-option
                  v-for="item in breedCodeList"
                  :key="item.breedCode"
                  :value="item.breedCode">
                  {{ item.breedCode }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12" >
            <a-form-item :label="$t('label.breedingContract')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['conCode']" :disabled="true" placeholder="请输入结算单号" ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12" >
            <a-form-item :label="$t('label.settlementDate')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date :placeholder="$t('label.pleaseSelectTheSettlementDate')"  v-decorator="['settlementDate',{'initialValue': initDocDate, rules: validatorRules.settlementDate.rules}]" :trigger-change="true" style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :span="12" >
            <a-form-item label="结算单号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['settlementCode']" :disabled="true" placeholder="请输入结算单号" ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12" >
            <a-form-item label="饲养品种" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag v-decorator="['breedVarietyCode']" :disabled="true" placeholder="请选择饲养品种" type="list" :trigger-change="true" :dictCode="dictBreedVarietyCode"></j-dict-select-tag>
            </a-form-item>
          </a-col>
          <a-col :span="12" >
            <a-form-item label="投苗数量" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['seedlingNumber']" :disabled="true" placeholder="请输入投苗数量" style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :span="12" >
            <a-form-item label="投苗日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date placeholder="请选择投苗日期" :disabled="true" v-decorator="['seedlingDate']" :trigger-change="true" style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :span="12" >
            <a-form-item label="销售日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date placeholder="请选择销售日期" :disabled="true" v-decorator="['saleDate']" :trigger-change="true" style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :span="12" >
            <a-form-item label="日龄" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['days']" :disabled="true" placeholder="请输入日龄" style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :span="12" >
            <a-form-item label="死淘差异" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['deadAmoyDifference']" :disabled="true" placeholder="请输入死淘差异" style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :span="12" >
            <a-form-item label="上市率(%)" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['listingRate']" :disabled="true" placeholder="请输入上市率(%)" style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :span="12" >
            <a-form-item label="料肉比" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['meatRatio']" :disabled="true" placeholder="请输入料肉比" style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :span="12" >
            <a-form-item label="上市公禽均重（只/kg）" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number :precision="2" v-decorator="['cockAverageWeight']" :disabled="true" placeholder="请输入上市公禽均重（只/kg）" style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :span="12" >
            <a-form-item label="上市母禽均重（只/kg）" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number :precision="2" v-decorator="['henAverageWeight']" :disabled="true" placeholder="请输入上市母禽均重（只/kg）" style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :span="12" >
            <a-form-item label="上市均重（只/kg）" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number :precision="2" v-decorator="['averageWeight']" :disabled="true" placeholder="请输入上市均重（只/kg）" style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :span="12" >
            <a-form-item label="回收总金额（元）" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number :precision="2" v-decorator="['recoveryAmount']" :disabled="true" placeholder="请输入回收总金额（元）" style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :span="12" >
            <a-form-item label="禽苗款（元）" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['chickenModel']" :disabled="true" placeholder="请输入禽苗款（元）" style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :span="12" >
            <a-form-item label="饲料款（元）" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['feedMoney']" :disabled="true" placeholder="请输入饲料款（元）" style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :span="12" >
            <a-form-item label="用药款（元）" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['medication']" :disabled="true" placeholder="请输入用药款（元）" style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :span="12" >
            <a-form-item :label="$t('label.basicSurrogateFee')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['surrogateSupport']" :disabled="true" placeholder="请输入基本代养费" style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :span="12" >
            <a-form-item label="上市率补贴（元）" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number :precision="2" v-decorator="['listingSubsidies',validatorRules.listingSubsidies]" placeholder="请输入上市率补贴（元）" style="width: 100%" @change="subsidyChanged($event,'1')"/>
            </a-form-item>
          </a-col>
          <a-col :span="12" >
            <a-form-item label="药费补贴（元）" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number :precision="2" v-decorator="['medicineSubsidy',validatorRules.medicineSubsidy]" placeholder="请输入药费补贴（元）" style="width: 100%" @change="subsidyChanged($event,'2')"/>
            </a-form-item>
          </a-col>
          <a-col :span="12" >
            <a-form-item :label="$t('label.otherSubsidies')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number :precision="2" v-decorator="['otherSubsidies',validatorRules.otherSubsidies]" :placeholder="$t('label.pleaseEnterOtherSubsidies')" style="width: 100%" @change="subsidyChanged($event,'3')"/>
            </a-form-item>
          </a-col>
          <a-col :span="12" >
            <a-form-item label="补贴小计（元）" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number  :disabled="true" v-decorator="['subsidy',validatorRules.subsidy]" placeholder="请输入补贴小计（元）" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="12" >
            <a-form-item label="资金占用费（元）" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number :precision="2" v-decorator="['capitalOccupation',validatorRules.capitalOccupation]" placeholder="请输入资金占用费（元）" style="width: 100%" @change="deductionSubtotalChanged($event,'1')"/>
            </a-form-item>
          </a-col>
          <a-col :span="12" >
            <a-form-item label="禽苗押金扣款" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number :precision="2" v-decorator="['depositDeduction',validatorRules.depositDeduction]" placeholder="请输入禽苗押金扣款" style="width: 100%" @change="deductionSubtotalChanged($event,'2')"/>
            </a-form-item>
          </a-col>
          <a-col :span="12" >
            <a-form-item label="其他处罚" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number :precision="2" v-decorator="['otherPenalties',validatorRules.otherPenalties]" placeholder="请输入其他处罚" style="width: 100%" @change="deductionSubtotalChanged($event,'3')"/>
            </a-form-item>
          </a-col>
          <a-col :span="12" >
            <a-form-item label="扣款小计（元）" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number  :disabled="true" v-decorator="['deductionSubtotal',validatorRules.deductionSubtotal]" placeholder="请输入扣款小计（元）" style="width: 100%"/>
            </a-form-item>
          </a-col>

          <a-col :span="12" >
            <a-form-item label="实际支付代养费" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['surrogateMaintenancePayment',validatorRules.surrogateMaintenancePayment]" :disabled="true" placeholder="请输入实际支付代养费" style="width: 100%" />
            </a-form-item>
          </a-col>

          <a-col :span="12" >
            <a-form-item :label="$t('label.marginBalance')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number  :disabled="true" v-decorator="['marginBalance',validatorRules.marginBalance]" placeholder="请输入保证金余额" style="width: 100%"/>
            </a-form-item>
          </a-col>


          <a-col :span="12" >
            <a-form-item :label="$t('label.marginWithholding')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number   v-decorator="['marginWithholding',validatorRules.marginWithholding]" placeholder="请输入保证金扣缴" style="width: 100%" @change="marginWithholdingChange"/>
            </a-form-item>
          </a-col>

          <a-col :span="12" >
            <a-form-item label="实际代养费" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number  v-decorator="['actualSurrogateSupport',validatorRules.actualSurrogateSupport]" :disabled="true" placeholder="请输入实际代养费" style="width: 100%" />
            </a-form-item>
          </a-col>

          <a-col :span="12" >
            <a-form-item :label="$t('label.remarks')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!-- <a-input v-decorator="['remarks']" placeholder="请输入备注" ></a-input> -->
              <mtc-lang-popover :whetherLang="whetherLang('remarks')" :popLists="getMainTablePop('remarks')">
                <a-input
                  v-decorator="['remarks']"
                  :read-only="whetherLang('remarks')"
                  @click="isLangClick('remarks', false)"
                  :placeholder="$t('label.pleaseEnterANote')"
                ></a-input>
              </mtc-lang-popover>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
      <!-- 子表单区域 -->
    <a-tabs v-model="activeKey" @change="handleChangeTabs">
      <a-tab-pane tab="回收明细" :key="refKeys[0]" :forceRender="true">
        <j-editable-table
          :ref="refKeys[0]"
          :tableName="subTable[0]"
          :loading="recyclingDetailsTable.loading"
          :columns="recyclingDetailsTable.columns"
          :dataSource="recyclingDetailsTable.dataSource"
          :maxHeight="300"
          :disabled="formDisabled"
          :rowNumber="true"
          :rowSelection="true"
          :actionButton="false"/>
      </a-tab-pane>

      <a-tab-pane tab="禽苗明细" :key="refKeys[1]" :forceRender="true">
        <j-editable-table
          :ref="refKeys[1]"
          :tableName="subTable[1]"
          :loading="chickenDetailsTable.loading"
          :columns="chickenDetailsTable.columns"
          :dataSource="chickenDetailsTable.dataSource"
          :maxHeight="300"
          :disabled="formDisabled"
          :rowNumber="true"
          :rowSelection="true"
          :actionButton="false"/>
      </a-tab-pane>

      <a-tab-pane  :tab="$t('tabName.feedDetail')" :key="refKeys[2]" :forceRender="true">
        <j-editable-table
          :ref="refKeys[2]"
          :tableName="subTable[2]"
          :loading="feedDetailsTable.loading"
          :columns="feedDetailsTable.columns"
          :dataSource="feedDetailsTable.dataSource"
          :maxHeight="300"
          :disabled="formDisabled"
          :rowNumber="true"
          :rowSelection="true"
          :actionButton="false"/>
      </a-tab-pane>

      <a-tab-pane tab="用药明细" :key="refKeys[3]" :forceRender="true">
        <j-editable-table
          :ref="refKeys[3]"
          :tableName="subTable[3]"
          :loading="nedicationDetailsTable.loading"
          :columns="nedicationDetailsTable.columns"
          :dataSource="nedicationDetailsTable.dataSource"
          :maxHeight="300"
          :disabled="formDisabled"
          :rowNumber="true"
          :rowSelection="true"
          :actionButton="false"/>
      </a-tab-pane>
    </a-tabs>
    <a-row v-if="showFlowSubmitButton" style="text-align: center;width: 100%;margin-top: 16px;"><a-button @click="handleOk">{{$t('button.submit')}}</a-button></a-row>
  </a-spin>
</template>

<script>

  import pick from 'lodash.pick'
  import { getAction } from '@/api/manage'
  import { FormTypes,getRefPromise } from '@/utils/JEditableTableUtil'
  import { JEditableTableMixin } from '@/mixins/JEditableTableMixin'
  import { validateDuplicateValue } from '@/utils/util'
  import {ajaxGetDictItems,getBreedCodeData} from '@/api/api'
  import moment from "moment";

  export default {
    name: 'EfsMdBillForm',
    mixins: [JEditableTableMixin],
    components: {
    },
    data() {
      return {
        mainTable: 'efs_md_bill',
        subTable: ['efs_md_bill_detail', 'efs_md_bill_detail', 'efs_md_bill_detail', 'efs_md_bill_detail'],
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        labelCol2: {
          xs: { span: 24 },
          sm: { span: 3 },
        },
        wrapperCol2: {
          xs: { span: 24 },
          sm: { span: 20 },
        },
        // 新增时子表默认添加几行空数据
        addDefaultRowNum: 1,
        validatorRules: {
            settlementDate: {
                rules: [
                    { required: true, message: '请选择结算日期!'},
                ]
            },
            breedCode: {
                rules: [
                    { required: true, message: '请选择批次号!'},
                ]
            },
            listingSubsidies: {
                rules: [
                    { required: true, message: '请输入上市率补贴（元）!'},
                ]
            },
            medicineSubsidy: {
                rules: [
                    { required: true, message: '请输入药费补贴（元）!'},
                ]
            },
            otherSubsidies: {
                rules: [
                    { required: true, message: '请输入其他补贴!'},
                ]
            },
            subsidy: {
                rules: [
                    { required: true, message: '请输入补贴小计（元）!'},
                ]
            },
            capitalOccupation: {
                rules: [
                    { required: true, message: '请输入资金占用费（元）!'},
                ]
            },
            depositDeduction: {
                rules: [
                    { required: true, message: '请输入禽苗押金扣款!'},
                ]
            },
            otherPenalties: {
                rules: [
                    { required: true, message: '请输入其他处罚!'},
                ]
            },
            marginWithholding: {
                rules: [
                    { required: true, message: '请输入保证金扣缴!'},
                    { pattern: /^\d+(\.\d+)?$/, message: '请输入正数!'},
                ]
            },

        },
        breedCodeList:[],
        refKeys: ['recyclingDetails', 'chickenDetails','feedDetails','nedicationDetails'],
        tableKeys:['recyclingDetails', 'chickenDetails','feedDetails','nedicationDetails'],
        activeKey: 'recyclingDetails',
        // 回收明细
        recyclingDetailsTable: {
          loading: false,
          tableName: 'efs_md_bill_detail',
          dataSource: [],
          columns: [
            {
              title: '物料代码',
              key: 'mmCode',
              type: FormTypes.input,
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue:'',
              disabled:true,
            },
            {
              title: this.$t('tableHeader.materialName'),
              key: 'mmName',
              type: FormTypes.input,
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue:'',
                disabled:true,
            },
            {
              title: this.$t('tableHeader.quantity'),
              key: 'qty',
              type: FormTypes.inputNumber,
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue:'',
                disabled:true,
            },
              {
                  title: '回收重量',
                  key: 'avgWeight',
                  type: FormTypes.inputNumber,
                  width:"200px",
                  placeholder: this.$t('tip.pleaseInput') +'${title}',
                  defaultValue:'',
                  disabled:true,
              },
            {
              title: '回收单价',
              key: 'recoveryUnitPrice',
              type: FormTypes.inputNumber,
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue:'',
                disabled:true,
            },
            {
              title: '金额',
              key: 'amount',
              type: FormTypes.inputNumber,
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue:'',
                disabled:true,
            },
              {
                  title: '结算类型',
                  key: 'settlementType',
                  type: FormTypes.hidden,
                  defaultValue:'',
                  disabled:true,
              },
          ]
        },

         //禽苗明细
          chickenDetailsTable: {
              loading: false,
              tableName: 'efs_md_bill_detail',
              dataSource: [],
              columns: [
                  {
                      title: '物料代码',
                      key: 'mmCode',
                      type: FormTypes.input,
                      width:"200px",
                      placeholder: this.$t('tip.pleaseInput') +'${title}',
                      defaultValue:'',
                      disabled:true,
                  },
                  {
                      title: this.$t('tableHeader.materialName'),
                      key: 'mmName',
                      type: FormTypes.input,
                      width:"200px",
                      placeholder: this.$t('tip.pleaseInput') +'${title}',
                      defaultValue:'',
                      disabled:true,
                  },
                  {
                      title: this.$t('tableHeader.quantity'),
                      key: 'qty',
                      type: FormTypes.inputNumber,
                      width:"200px",
                      placeholder: this.$t('tip.pleaseInput') +'${title}',
                      defaultValue:'',
                      disabled:true,
                  },
                  {
                      title: '平均单价',
                      key: 'averageUnitPrice',
                      type: FormTypes.inputNumber,
                      width:"200px",
                      placeholder: this.$t('tip.pleaseInput') +'${title}',
                      defaultValue:'',
                      disabled:true,
                  },
                  {
                      title: '金额',
                      key: 'amount',
                      type: FormTypes.inputNumber,
                      width:"200px",
                      placeholder: this.$t('tip.pleaseInput') +'${title}',
                      defaultValue:'',
                      disabled:true,
                  },
                  {
                      title: '结算类型',
                      key: 'settlementType',
                      type: FormTypes.hidden,
                      defaultValue:'',
                      disabled:true,
                  },
              ]
          },


          //饲料明细
          feedDetailsTable: {
              loading: false,
              dataSource: [],
              tableName: 'efs_md_bill_detail',
              columns: [
                  {
                      title: '物料代码',
                      key: 'mmCode',
                      type: FormTypes.input,
                      width:"200px",
                      placeholder: this.$t('tip.pleaseInput') +'${title}',
                      defaultValue:'',
                      disabled:true,
                  },
                  {
                      title: this.$t('tableHeader.materialName'),
                      key: 'mmName',
                      type: FormTypes.input,
                      width:"200px",
                      placeholder: this.$t('tip.pleaseInput') +'${title}',
                      defaultValue:'',
                      disabled:true,
                  },
                  {
                      title: this.$t('tableHeader.quantity'),
                      key: 'qty',
                      type: FormTypes.inputNumber,
                      width:"200px",
                      placeholder: this.$t('tip.pleaseInput') +'${title}',
                      defaultValue:'',
                      disabled:true,
                  },
                  {
                      title: '平均单价',
                      key: 'averageUnitPrice',
                      type: FormTypes.inputNumber,
                      width:"200px",
                      placeholder: this.$t('tip.pleaseInput') +'${title}',
                      defaultValue:'',
                      disabled:true,
                  },
                  {
                      title: '金额',
                      key: 'amount',
                      type: FormTypes.inputNumber,
                      width:"200px",
                      placeholder: this.$t('tip.pleaseInput') +'${title}',
                      defaultValue:'',
                      disabled:true,
                  },
                  {
                      title: '结算类型',
                      key: 'settlementType',
                      type: FormTypes.hidden,
                      defaultValue:'',
                      disabled:true,
                  },
              ]
          },

          //用药明细
          nedicationDetailsTable: {
              loading: false,
              tableName: 'efs_md_bill_detail',
              dataSource: [],
              columns: [
                  {
                      title: '物料代码',
                      key: 'mmCode',
                      type: FormTypes.input,
                      width:"200px",
                      placeholder: this.$t('tip.pleaseInput') +'${title}',
                      defaultValue:'',
                      disabled:true,
                  },
                  {
                      title: this.$t('tableHeader.materialName'),
                      key: 'mmName',
                      type: FormTypes.input,
                      width:"200px",
                      placeholder: this.$t('tip.pleaseInput') +'${title}',
                      defaultValue:'',
                      disabled:true,
                  },
                  {
                      title: this.$t('tableHeader.quantity'),
                      key: 'qty',
                      type: FormTypes.inputNumber,
                      width:"200px",
                      placeholder: this.$t('tip.pleaseInput') +'${title}',
                      defaultValue:'',
                      disabled:true,
                  },
                  {
                      title: '平均单价',
                      key: 'averageUnitPrice',
                      type: FormTypes.inputNumber,
                      width:"200px",
                      placeholder: this.$t('tip.pleaseInput') +'${title}',
                      defaultValue:'',
                      disabled:true,
                  },
                  {
                      title: '金额',
                      key: 'amount',
                      type: FormTypes.inputNumber,
                      width:"200px",
                      placeholder: this.$t('tip.pleaseInput') +'${title}',
                      defaultValue:'',
                      disabled:true,
                  },
                  {
                      title: '结算类型',
                      key: 'settlementType',
                      type: FormTypes.hidden,
                      defaultValue:'',
                      disabled:true,
                  },
              ]
          },

        url: {
          add: "/settlementReceipt/efsMdBill/add",
          edit: "/settlementReceipt/efsMdBill/edit",
          queryById: "/settlementReceipt/efsMdBill/queryById",
          recyclingDetails: {
            list: '/settlementReceipt/efsMdBill/getRecyclingDetailsList'
          },
            chickenDetails: {
                list: '/settlementReceipt/efsMdBill/getChickenDetailsList'
            },
            feedDetails: {
                list: '/settlementReceipt/efsMdBill/getFeedDetailsList'
            },
            nedicationDetails: {
                list: '/settlementReceipt/efsMdBill/getNedicationDetailsList'
            },
            recyclingDetailsNew: '/settlementReceipt/efsMdBill/getRecyclingDetails',
            chickenDetailsNew: '/settlementReceipt/efsMdBill/getChickenDetails',
            feedDetailsNew: '/settlementReceipt/efsMdBill/getFeedDetails',
            nedicationDetailsNew: '/settlementReceipt/efsMdBill/getNedicationDetails',
            queryByBreedCode: '/settlementReceipt/efsMdBill/getBreedOrder',
        },
          initDocDate: moment(new Date()).format('YYYY-MM-DD'),
          dictBreedVarietyCode: "",
      }
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：false流程表单 true普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      addBefore(){
          getBreedCodeData().then((res) => {
              if (res.success) {
                  this.breedCodeList = res.result;
              }
          });
        this.form.resetFields()
        this.recyclingDetailsTable.dataSource=[];
          this.chickenDetailsTable.dataSource=[];
          this.feedDetailsTable.dataSource=[];
          this.nedicationDetailsTable.dataSource=[];
      },
      getAllTable() {
        let values = this.tableKeys.map(key => getRefPromise(this, key))
        return Promise.all(values)
      },
      /** 调用完edit()方法之后会自动调用此方法 */
      editAfter() {
        let fieldval = pick(this.model,'breedCode','conCode','settlementDate','settlementCode','breedVarietyCode','seedlingNumber','seedlingDate','days','saleDate','deadAmoyDifference','listingRate','meatRatio','cockAverageWeight','henAverageWeight','averageWeight','recoveryAmount','chickenModel','feedMoney','medication','surrogateSupport','listingSubsidies','medicineSubsidy','otherSubsidies','subsidy','capitalOccupation','depositDeduction','otherPenalties','surrogateMaintenancePayment','remarks','createBy','createTime','updateBy','updateTime','sysOrgCode','buffer1','buffer2','buffer3','buffer4','buffer5','notes','validFlag','delFlag','status','deductionSubtotal','marginBalance','actualSurrogateSupport','marginWithholding')
        this.$nextTick(() => {
          this.form.setFieldsValue(fieldval)
        })
        // 加载子表数据
        if (this.model.id) {
          let params = { id: this.model.id }
          this.requestSubTableData(this.url.recyclingDetails.list, params, this.recyclingDetailsTable);
          this.requestSubTableData(this.url.chickenDetails.list, params, this.chickenDetailsTable);
          this.requestSubTableData(this.url.feedDetails.list, params, this.feedDetailsTable);
          this.requestSubTableData(this.url.nedicationDetails.list, params, this.nedicationDetailsTable);
        }
      },
      /** 整理成formData */
      classifyIntoFormData(allValues) {
        let main = Object.assign(this.model, allValues.formValue)
        return {
          ...main, // 展开
            recyclingDetailsList: allValues.tablesValue[0].values,
            chickenDetailsList: allValues.tablesValue[1].values,
            feedDetailsList: allValues.tablesValue[2].values,
            nedicationDetailsList: allValues.tablesValue[3].values,
        }
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          })
        }
      },
      validateError(msg){
        this.$message.error(msg)
      },
     popupCallback(row){
       this.form.setFieldsValue(pick(row,'breedCode','conCode','settlementDate','settlementCode','breedVarietyCode','seedlingNumber','seedlingDate','days','saleDate','deadAmoyDifference','listingRate','meatRatio','cockAverageWeight','henAverageWeight','averageWeight','recoveryAmount','chickenModel','feedMoney','medication','surrogateSupport','listingSubsidies','medicineSubsidy','otherSubsidies','subsidy','capitalOccupation','depositDeduction','otherPenalties','surrogateMaintenancePayment','remarks','createBy','createTime','updateBy','updateTime','sysOrgCode','buffer1','buffer2','buffer3','buffer4','buffer5','notes','validFlag','delFlag','status','deductionSubtotal','marginBalance','actualSurrogateSupport','marginWithholding'))
     },
        breedCodeChanged(code) {
            //提取主数据
            getAction(this.url.queryByBreedCode, { breedCode: code }).then(res => {
                if (res.success) {
                    this.form.resetFields()
                    this.form.setFieldsValue({
                        breedCode: res.result.breedCode,
                        conCode: res.result.conCode,
                        breedVarietyCode: res.result.breedVarietyCode,
                        seedlingNumber: res.result.seedlingNumber,
                        seedlingDate: res.result.seedlingDate,
                        saleDate: res.result.saleDate,
                        days: res.result.days,
                        deadAmoyDifference: res.result.deadAmoyDifference,
                        listingRate: res.result.listingRate,
                        meatRatio: res.result.meatRatio,
                        averageWeight: res.result.averageWeight,
                        recoveryAmount: res.result.recoveryAmount,
                        chickenModel: res.result.chickenModel,
                        feedMoney: res.result.feedMoney,
                        medication: res.result.medication,
                        surrogateSupport: res.result.surrogateSupport,
                        henAverageWeight: res.result.henAverageWeight,
                        cockAverageWeight: res.result.cockAverageWeight,
                        marginBalance: res.result.marginBalance,

                    });
                    this.dictBreedVarietyCode = "sys_category,name,code,pid=(select id from sys_category where code= '" + res.result.breedClassCode + "')";
                } else {
                    this.$message.warning(res.message)
                }
            });
            //提取回收明细
            getAction(this.url.recyclingDetailsNew, { breedCode: code}).then(res => {
                if (res.success) {
                    this.recyclingDetailsTable.dataSource=[];
                    this.recyclingDetailsTable.dataSource=res.result.efsMdBillDetailList;
                    this.$refs.recyclingDetails.$forceUpdate();

                } else {
                    this.$message.warning(res.message)
                }
            });
            //提取禽苗明细
            getAction(this.url.chickenDetailsNew, { breedCode: code}).then(res => {
                if (res.success) {
                    this.chickenDetailsTable.dataSource=[];
                    this.chickenDetailsTable.dataSource=res.result.efsMdBillDetailList;
                    this.$refs.chickenDetails.$forceUpdate();

                } else {
                    this.$message.warning(res.message)
                }
            });
            //提取饲料明细
            getAction(this.url.feedDetailsNew, { breedCode: code}).then(res => {
                if (res.success) {
                    this.feedDetailsTable.dataSource=[];
                    this.feedDetailsTable.dataSource=res.result.efsMdBillDetailList;
                    this.$refs.feedDetails.$forceUpdate();

                } else {
                    this.$message.warning(res.message)
                }
            });
            //提取用药明细
            getAction(this.url.nedicationDetailsNew, { breedCode: code}).then(res => {
                if (res.success) {
                    this.nedicationDetailsTable.dataSource=[];
                    this.nedicationDetailsTable.dataSource=res.result.efsMdBillDetailList;
                    this.$refs.nedicationDetails.$forceUpdate();

                } else {
                    this.$message.warning(res.message)
                }
            });
        },

        subsidyChanged(event,type){
           let listingSubsidies;
           if(type=="1"){
                listingSubsidies= event;
           }else{
                listingSubsidies= this.form.getFieldValue('listingSubsidies');
           }
            let medicineSubsidy;
            if(type=="2"){
                medicineSubsidy=event;
            }else{
                medicineSubsidy= this.form.getFieldValue('medicineSubsidy');
            }
            let otherSubsidies;
            if(type=="3"){
                otherSubsidies=event;
            }else{
                otherSubsidies= this.form.getFieldValue('otherSubsidies');
            }
           if(listingSubsidies!=null&&medicineSubsidy!=null&&otherSubsidies!=null){
               let total=Number(listingSubsidies+medicineSubsidy+otherSubsidies).toFixed(2);
               this.form.setFieldsValue({subsidy:total});
           }else{
               this.form.setFieldsValue({subsidy:0});
           }
           //基本代养费
           let surrogateSupport=this.form.getFieldValue('surrogateSupport');
           //补贴小计
           let subsidy=this.form.getFieldValue('subsidy');
           //扣款小计
           let deductionSubtotal=this.form.getFieldValue('deductionSubtotal');
           if(surrogateSupport!=null&&subsidy!=null&&deductionSubtotal!=null){
               let total=(Number(surrogateSupport)+Number(subsidy)-Number(deductionSubtotal)).toFixed(2);
               this.form.setFieldsValue({surrogateMaintenancePayment:total});
           }else{
               this.form.setFieldsValue({surrogateMaintenancePayment:0});
           }
        },
        deductionSubtotalChanged(event,type){
            let capitalOccupation;
            if(type=="1"){
                capitalOccupation= event;
            }else{
                capitalOccupation= this.form.getFieldValue('capitalOccupation');
            }
            let depositDeduction;
            if(type=="2"){
                depositDeduction=event;
            }else{
                depositDeduction= this.form.getFieldValue('depositDeduction');
            }
            let otherPenalties;
            if(type=="3"){
                otherPenalties=event;
            }else{
                otherPenalties= this.form.getFieldValue('otherPenalties');
            }
            if(capitalOccupation!=null&&depositDeduction!=null&&otherPenalties!=null){
                let total=Number(capitalOccupation+depositDeduction+otherPenalties).toFixed(2);
                this.form.setFieldsValue({deductionSubtotal:total});
            }else{
                this.form.setFieldsValue({deductionSubtotal:0});
            }
            //基本代养费
            let surrogateSupport=this.form.getFieldValue('surrogateSupport');
            //补贴小计
            let subsidy=this.form.getFieldValue('subsidy');
            //扣款小计
            let deductionSubtotal=this.form.getFieldValue('deductionSubtotal');
            if(surrogateSupport!=null&&subsidy!=null&&deductionSubtotal!=null){
                let total=(Number(surrogateSupport)+Number(subsidy)-Number(deductionSubtotal)).toFixed(2);
                this.form.setFieldsValue({surrogateMaintenancePayment:total});
            }else{
                this.form.setFieldsValue({surrogateMaintenancePayment:0});
            }
        },

        marginWithholdingChange(value){
            //实际支付代养费
            let surrogateMaintenancePayment=0;
            if(this.form.getFieldValue('surrogateMaintenancePayment')){
                surrogateMaintenancePayment=this.form.getFieldValue('surrogateMaintenancePayment');
            }
            //保证金余额
            let marginBalance=this.form.getFieldValue('marginBalance');
            let total=Number(surrogateMaintenancePayment)+Number(marginBalance);
            if(Number(value)>Number(total)){
                this.form.setFieldsValue({marginWithholding:0});
            }

            if(surrogateMaintenancePayment==0||value==null){
                this.form.setFieldsValue({actualSurrogateSupport:0});
            }else{
                let total=Number(surrogateMaintenancePayment)-Number(value);
                this.form.setFieldsValue({actualSurrogateSupport:total});
            }

        }
    }
  }
</script>

<style scoped>
</style>